<tools-menu></tools-menu>
<hr>

<alert-component *ngIf="alert" [message]="alert">
</alert-component>

<loading-component *ngIf="_resourceService.loading"></loading-component>

<div class="d-flex justify-content-center">
  <button class="btn btn-main-color btn-sm  cursor-hand" (click)="clearCache()">
    {{ 'CLEAR_CACHE' | translate }}
  </button>
</div>